import TextField from '@mui/material/TextField';
import parsePhoneNumberFromString from 'libphonenumber-js';

// Arabic-Indic (U+0660-0669), Eastern Arabic-Indic (U+06F0-06F9) and fullwidth (U+FF10-FF19) digits to ASCII,
// and fullwidth plus (U+FF0B) to '+'.
const toAsciiDigits = (s) => s
    .replace(/[\u0660-\u0669\u06F0-\u06F9\uFF10-\uFF19]/g, (d) => {
        const code = d.charCodeAt(0);
        return String(code - (code >= 0xFF10 ? 0xFF10 : code >= 0x06F0 ? 0x06F0 : 0x0660));
    })
    .replace(/\uFF0B/g, '+');

const CustomTextField = ({ label, onChange, value, disabled, type, autoFocus, inputProps }) => {
    const handleInputChange = (e) => {
        const inputValue = e.target.value;

        // Perform type-specific validation and formatting
        let formattedInputValue;
        switch (type) {
            case 'phone_number':
                formattedInputValue = formatPhoneNumber(inputValue);
                break;
            case 'tracking_number':
                formattedInputValue = inputValue.replace(/[^A-Za-z0-9 -]/g, '').toUpperCase().substring(0, 30);
                break;
            case 'invoice_number':
                formattedInputValue = inputValue.substring(0, 60);
                break;
            case 'verify_phone':
                formattedInputValue = toAsciiDigits(inputValue).substring(0, 40);
                break;
            default:
                formattedInputValue = inputValue;
        }

        // Call the provided onChange function with the formatted value
        onChange(formattedInputValue);
    };

    const formatPhoneNumber = (phoneNumber) => {
        // Remove non-digit characters from the input
        const cleanedPhoneNumber = phoneNumber.replace(/[^0-9 +-\\)\\(]/g, '');
        const parsedPhoneNumber = parsePhoneNumberFromString(cleanedPhoneNumber);

        // Check if the phone number is valid and format it
        if (parsedPhoneNumber && parsedPhoneNumber.isValid()) {
            return parsedPhoneNumber.formatNational();
        }
        return cleanedPhoneNumber;
    };

    return (
        <TextField
            fullWidth
            id="track-input"
            // variant="filled"
            sx={{
                input: {
                    background: "white"
                }
            }}
            size="small"
            label={label}
            value={value}
            onChange={handleInputChange}
            disabled={disabled}
            autoFocus={autoFocus}
            inputProps={inputProps}
        />
    );
};

export default CustomTextField;
